import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  GET_ALL_SHOPS,
  CREATE_SHOP,
  UPDATE_SHOP,
  DELETE_SHOP,
} from "./actionTypes";
import {
  getAllShopsCall,
  createShopCall,
  updateShopCall,
  deleteShopCall,
  API_URL,
} from "../../../helpers/repository";
import { getAllShops, getAllShopsResponseSuccess } from "./actions";
import { showErrorMessages } from "../../../helpers/helpers";

import { apiError } from "../../../store/actions";
import { showMessage } from "../../../components/Common/Toaster";

function* attemptGetAllShops() {
  try {
    const response = yield call(getAllShopsCall);
    yield put(getAllShopsResponseSuccess(response.data.data));
  } catch (error) {
    showErrorMessages(error);
  }
}

function* attemptCreateShop(action) {
  const { history } = action;
  try {
    const response = yield call(createShopCall, action.payload);
    showMessage("success", response.data.message);
  
    history.push("/admin/shops");
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors));
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditShop(action) {
  const { history, id } = action;
  try {
    const response = yield call(updateShopCall, action.payload, id);
    showMessage("success", response.data.message);
    yield put(getAllShops());
    history.push("/admin/shops");
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors));
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeleteShop(action) {
  try {
    const response = yield call(deleteShopCall, action.payload);
    showMessage("success", response.data.message);
    yield put(getAllShops());
  } catch (error) {
    showErrorMessages(error);
  }
}

function* ShopsSaga() {
  yield takeEvery(GET_ALL_SHOPS, attemptGetAllShops);
  yield takeEvery(CREATE_SHOP, attemptCreateShop);
  yield takeEvery(UPDATE_SHOP, attemptEditShop);
  yield takeEvery(DELETE_SHOP, attemptDeleteShop);
}

export default ShopsSaga;
